import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./assets/styles/global.css";

createRoot(document.getElementById("root")).render(<App />);
